import { takeLatest, all, fork, call, put, select } from "redux-saga/effects";
// import { failureSavingName, sucessSavingName } from "../action";
import { SavingTypes } from "../action/index.model";
import SDK from "./../../../sdk";
import { successSavingName, updatedNameId } from "../action";
import { updateGivenName } from "./../../../LineDetails/actions/index";
import { updateApiCallStatus } from "app/actions";
import { RootState } from "app/reducers";
const state = (state: RootState) => state;
export function* GetNameCardSavingName(action: any): any {
  try {
    const stateData: RootState = yield select(state);
    const payload = {
      tmoLineProfile: { givenName: action.data.givenName },
      customHeaders: null, 
    };
    const apiStatusData = stateData.app.apiCallsStatus.find(
      (item) => item.module === SavingTypes.UPDATE_SAVING_NAME
    );
    let noOfAttempts: number = 0;
    if (apiStatusData && apiStatusData?.noOfAttempts) {
      noOfAttempts = apiStatusData.noOfAttempts;
    }
    yield put(
      updateApiCallStatus({
        status: "pending",
        module: SavingTypes.UPDATE_SAVING_NAME,
        noOfAttempts: noOfAttempts + 1,
      })
    );
    const response = yield call(SDK.updateLineName, action.data.id, payload);
    // yield call(SDK.getLineName, action.data.id);
    if (response?.tmoLineProfile?.givenName) {
      yield put(updatedNameId({ id: action.data.id }));
      yield put(updateGivenName(action.data));
      yield put(
        updateApiCallStatus({
          status: "success",
          module: SavingTypes.UPDATE_SAVING_NAME,
          noOfAttempts: 0,
        })
      );
      yield put(
        successSavingName({
          message: "You have successfully changed the name of the line",
        })
      );
    } else {
      // yield put(failureSavingName({ isError: true }));
      throw new Error("updating name failed");
    }
  } catch (error) {
    console.log(error, "error");
    // yield put(failureSavingName({ isError: true }));
    yield put(
      updateApiCallStatus({
        status: "error",
        module: SavingTypes.UPDATE_SAVING_NAME,
      })
    );
  }
}

function* getNameCardSaving() {
  yield takeLatest(SavingTypes.UPDATE_SAVING_NAME, GetNameCardSavingName);
}

export default function* NameCardSaga() {
  yield all([fork(getNameCardSaving)]);
}
